export default __webpack_public_path__ + "static/media/home-search-cars.32689000.jpg";